import React, { Component } from "react";
import Ripple from "./ripple.gif";
// import { ReactComponent as LoadingScreenMobile } from "./LoadingScreen.svg";
// import { ReactComponent as LoadingScreenDesktop } from "./LoadingScreenDesktop.svg";
import LoadingScreenDesktop from "./LoadingScreenDesktop.svg";
import LoadingScreen from "./LoadingScreen.svg";
import instance from "../../store/actions/instance";
// import {ReactComponent as CircularProgress} from "@material-ui/core/CircularProgress";
import { ReactComponent as CircularProgress } from "./loading.svg";

export default function CircularIndeterminate() {
  return (
    <div
      className=" text-center"
      style={{
        backgroundColor: "transparent",
        //backgroundImage: `url(${this.state.image})`,

        /* Full height */
        height: "100%",

        /* Center and scale the image nicely */
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
    >
      <div
        style={{
          width: 150,
          height: 150,
          borderRadius: 25,
          position: "absolute",
          top: "calc(50% - 75px)",
          left: "calc(50% - 75px)",
          zIndex: 2,
          backgroundColor: "transparent",
        }}
      >
        <CircularProgress
          style={{
            color: "#666",
            lineHeight: 1.5,
            marginTop: 12,
            marginRight: 0,
            width: 125,
            height: 125,
          }}
        />
      </div>
    </div>
  );
}
